<template>
  <v-layout row wrap>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand :value="[true]" class="mt-3">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
            <message :messages="messages"></message>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="params.schemes" v-model="filters.scheme" :label="filtersLabel.scheme" item-text="label" item-value="value" data-vv-name="scheme" :data-vv-as="filtersLabel.scheme" :error-messages="errors.collect('scheme')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="params.plans" v-model="filters.planNo" :label="filtersLabel.planNo" item-text="label" item-value="value" data-vv-name="planNo" :data-vv-as="filtersLabel.planNo" :error-messages="errors.collect('planNo')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6></v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.schemeMap" :label="filtersLabel.schemeMap" :error-messages="errors.collect('schemeMap')" data-vv-name="schemeMap" :data-vv-as="filtersLabel.schemeMap" v-validate="'entry|max:4'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.planNoMap" :label="filtersLabel.planNoMap" :error-messages="errors.collect('planNoMap')" data-vv-name="planNoMap" :data-vv-as="filtersLabel.planNoMap" v-validate="'entry|max:4'"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-2">
      <v-data-table :headers="listHeaders" :items="items" item-key="proposalNo" :pagination.sync="pagination" :total-items="totalItems" :loading="loading" :rows-per-page-items="itemsPerPage" :no-data-text="'No Posting Mappings found.'">
        <template slot="items" slot-scope="props">
          <td v-for="column in selectedColumns" :key="column">
            {{props.item[column]}}
          </td>
          <td class="text-xs-right">
            <table-action :rowData="props" :review="checkAccess(['paPostMap'])" :remove="checkAccess(['paPostMap'])" @remove="doPromptRemove(props)" @review="doReview(props)" :loading="loading"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNewMapping()">
        New Posting Mapping
        <v-icon right>mdi-playlist-plus</v-icon>
      </v-btn>
      <p-a-post-map-dialog v-model="paPostMapDialog" :newMap="newMap" :postMapId="postMapId" :params="params" @close="doClose"></p-a-post-map-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the following Mapping?
        <v-alert color="grey lighten-3" :value="true">
          <span class="deletePostMap">
            {{deletePostMap}}
          </span>
        </v-alert>
      </confirm>
    </v-flex>
  </v-layout>
</template>

<script>
import { postingMixin } from '../shared/postingMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import PAPostMapDialog from './PAPostMapDialog'
import * as TableConst from '@/mixins/table'

export default {
  data() {
    return {
      columns: [
        { text: 'Scheme', value: 'schemeDesc' },
        { text: 'Plan', value: 'planNoDesc' },
        { text: 'PA Area', value: 'paAreaDesc' },
        { text: 'Mapped Scheme', value: 'schemeMap' },
        { text: 'Mapped Plan', value: 'planNoMap' }
      ],
      selectedColumns: ['schemeDesc', 'planNoDesc', 'paAreaDesc', 'schemeMap', 'planNoMap'],
      filtersLabel: {
        scheme: 'Scheme',
        planNo: 'Plan',
        paArea: 'PA Area',
        schemeMap: 'Mapped Scheme',
        planNoMap: 'Mapped Plan'
      },
      filters: {
        scheme: null,
        planNo: null,
        paArea: null,
        schemeMap: null,
        planNoMap: null
      },
      params: {
        schemes: [],
        plans: [],
        paAreas: []
      },
      postMapId: {
        scheme: undefined,
        planNo: undefined,
        paArea: undefined
      },
      paPostMapDialog: false,
      newMap: false,
      promptRemove: false,
      selectedPostMap: undefined,
      deletePostMap: ''
    }
  },
  computed: {
    listHeaders() {
      let result = []
      for (const selectedColumn of this.selectedColumns) {
        let findCol = this.columns.find(a => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  methods: {
    async fetchData(options) {
      if (this.apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: rowsPerPage,
            options
          }

          const result = await this.$http.get(filterQuery(expandURI(this.apiUrl, expand), this.filters, this.pagination.sortBy, this.pagination.descending))

          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((postMap) => {
                const convertPostMap = {
                  scheme: postMap.scheme,
                  planNo: postMap.planNo,
                  paArea: postMap.paArea,
                  schemeDesc: postMap.scheme + ' - ' + postMap.schemeDesc,
                  planNoDesc: postMap.planNo + ' - ' + postMap.planDesc,
                  paAreaDesc: postMap.paAreaDesc,
                  schemeMap: postMap.schemeMap,
                  planNoMap: postMap.planNoMap
                }
                this.items.push(convertPostMap)
              })
            } else {
              this.items = []
            }
            if (options) {
              this.$set(this.params, 'schemes', result.data.schemes)
              this.$set(this.params, 'plans', result.data.plans)
              this.$set(this.params, 'paAreas', result.data.paAreas)
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doNewMapping() {
      this.paPostMapDialog = true
      this.newMap = true
    },
    doReview(data) {
      this.postMapId.scheme = data.item.scheme
      this.postMapId.planNo = data.item.planNo
      this.postMapId.paArea = data.item.paArea
      this.paPostMapDialog = true
      this.newMap = false
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedPostMap = data.item
        this.deletePostMap = data.item.schemeDesc + ' / ' + data.item.planNoDesc + ' / ' + data.item.paAreaDesc + ' -> ' + data.item.schemeMap + ' / ' + data.item.planNoMap
      }
    },
    async doRemove() {
      const apiURI = this.postingState.menu.paPostMapRemove
      if (apiURI) {
        this.loading = true
        const expand = {
          scheme: this.selectedPostMap.scheme,
          planNo: this.selectedPostMap.planNo,
          paArea: this.selectedPostMap.paArea
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          this.selectedPostMap = undefined
          this.deletePostMap = ''
          // Reinit
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doClose() {
      this.postMapId.scheme = undefined
      this.postMapId.planNo = undefined
      this.postMapId.paArea = undefined
      this.paPostMapDialog = false
      this.newMap = false
      this.$validator.reset()
      this.fetchData()
    },
    doClearFilters() {
      this.filters.scheme = null
      this.filters.planNo = null
      this.filters.paArea = null
      this.filters.schemeMap = null
      this.filters.planNoMap = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    }
  },
  watch: {
    'value': function (value) {
      if (value) {
        this.fetchData(false)
      } else {
        this.$emit('input', false)
      }
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.apiUrl = this.postingState.menu.paPostMap
  },
  mixins: [
    postingMixin
  ],
  components: {
    PAPostMapDialog
  }
}
</script>

<style lang="scss">
.deletePostMap {
  color: #666;
}
</style>
